if (!customElements.get('theme-sidenav')) {
  class Sidenav extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mainContent = document.querySelector('main#MainContent');
      if (!this.mainContent) return;

      this.setSectionsCount();

      this._sectionsObserver = new MutationObserver(() => this.setSectionsCount());
      this._sectionsObserver.observe(this.mainContent, { childList: true });
    }

    disconnectedCallback() {
      this._sectionsObserver?.disconnect();
    }

    setSectionsCount() {
      const sections = Array.from(this.mainContent.children).filter(el => el.matches('.shopify-section'));
      const ownWrapper = this.closest('.shopify-section');
      const ownIndex = sections.indexOf(ownWrapper) + 1;

      this.mainContent.style.setProperty('--sidenav-section-count', sections.length - ownIndex);
      this.mainContent.style.setProperty('--sidenav-index', ownIndex);
    }
  }

  customElements.define('theme-sidenav', Sidenav)
}
